function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2889 0C7.78507 0 3.32222 4.03 3.32222 9H0L4.30781 12.89L4.38533 13.03L8.85926 9H5.53704C5.53704 5.13 9.00322 2 13.2889 2C17.5746 2 21.0407 5.13 21.0407 9C21.0407 12.87 17.5746 16 13.2889 16C11.1516 16 9.21363 15.21 7.8183 13.94L6.24578 15.36C8.05085 16.99 10.5314 18 13.2889 18C18.7927 18 23.2556 13.97 23.2556 9C23.2556 4.03 18.7927 0 13.2889 0ZM12.1815 5V10L16.9212 12.54L17.7185 11.33L13.8426 9.25V5H12.1815Z",
  fill: "#0C3967"
});

function SvgLogoHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHistory);
export default __webpack_public_path__ + "static/media/Logo_History.42c1b97e.svg";
export { ForwardRef as ReactComponent };